import styled from 'styled-components';
import { HeroBannerWrapperComponent } from '../common/HeroBannerWrapperComponent.styles.';

const getBannerHeight = (props, deviceType) => {
  const headerHeight = props.heightCalculation || (deviceType === 'mobile' ? 80 : 90);
  if (props.bannerFixedRatio === 0) {
    // fixed height
    if (deviceType === 'mobile') {
      return `height: calc(100vh - ${headerHeight}px)`;
    } else {
      return `height: calc(100vh - ${headerHeight}px)`;
    }
  } else {
    // fixed aspect ratio
    if (deviceType === 'mobile') {
      return `height: 0; padding-top: ${(16 / 9) * 100}%;`;
    } else {
      return `height: 0; padding-top: ${(9 / 16) * 100}%;`;
    }
  }
};

export const HeroBannerWrapperComponent7 = styled(HeroBannerWrapperComponent)`
  @media screen and (min-width: 767px) {
    ${(props) => getBannerHeight(props, 'desktop')}
  }

  @media screen and (max-width: 766px) {
    ${(props) => getBannerHeight(props, 'mobile')}
  }
`;

export const HeroBannerComponent = styled.main`
  display: flex;
  width: 100%;
  flex: 1;
  position: relative;

  @media screen and (min-width: 767px) {
    ${(props) => getBannerHeight(props, 'desktop')}
  }

  @media screen and (max-width: 766px) {
    ${(props) => getBannerHeight(props, 'mobile')}
  }
`;

export const HeroBannerImage = styled.section`
  width: 100%;
  object-fit: cover;
  height: 100%;
  position: relative;

  & > .next-banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }

  @media screen and (min-width: 767px) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    & > .next-banner-image {
      filter: ${({ imageBrightness }) =>
        imageBrightness ? 'brightness(1)' : 'brightness(0.7)'};
      object-fit: cover;
    }
  }

  @media screen and (max-width: 766px) {
    height: 100%;

    & > .next-image {
      object-position: center top;
    }
  }
`;

export const HeroBannerInteractivePosition = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  @media screen and (min-width: 767px) {
    position: absolute;
    z-index: 5;
    height: 100%;
    width: 100%;
  }

  @media screen and (max-width: 766px) {
    height: 25%;
  }
`;

export const HeroBannerInteractiveBody = styled.div`
  width: 100%;

  @media screen and (min-width: 767px) {
    max-width: 500px;
    text-align: center;
  }

  @media screen and (max-width: 766px) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const HeroBannerSection = styled.div`
  display: flex;
  flex: 0 0 auto;
  height: fit-content;
  width: 100%;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 766px) {
    padding: 1rem 0;
  }
`;

export const HeroBannerStoreImage = styled.div`
  border-radius: ${(props) => props.roundness};
  overflow: hidden;
  object-fit: cover;
  margin: 0 auto;
  position: relative;

  & > .next-store-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }

  @media screen and (min-width: 767px) {
    height: 77px;
    width: 77px;
  }

  @media screen and (max-width: 766px) {
    height: 57px;
    width: 57px;
  }
`;

export const HeroBannerHeading = styled.h1`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (min-width: 767px) {
    color: #ffffff;
    font-size: 56px;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 766px) {
    color: ${(props) => props.primaryColor};
    font-size: 20px;
    margin-bottom: 0;
    text-align: center;
  }
`;

export const HeroBannerDescription = styled.p`
  display: none;

  @media screen and (min-width: 767px) {
    font-size: 16px;
    color: #ffffff;
    display: block;
    width: 100%;
    max-width: 350px;
    margin: 0 auto 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 4;
    -webkit-touch-callout: text;
    -webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
`;

export const HeroBannerCTAButton = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 766px) {
    display: none;
  }
`;

export const HeroBannerMainContent = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 767px) {
    flex-direction: row;
  }
`;
